/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube Thumbnail Downloader — Grab HD Thumbnails | Toolverse`)
};

const es_yt_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargador de Miniaturas de YouTube — Obtén Miniaturas HD | Toolverse`)
};

const de_yt_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube-Thumbnail-Downloader — HD-Thumbnails herunterladen | Toolverse`)
};

const nl_yt_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube Thumbnail Downloader — HD-thumbnails downloaden | Toolverse`)
};

const fr_yt_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargeur de miniatures YouTube — Récupérez des miniatures HD | Toolverse`)
};

const it_yt_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloader Miniature YouTube — Ottieni Miniature HD | Toolverse`)
};

const pt_br2_yt_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloader de Thumbnail do YouTube — Baixe Thumbnails em HD | Toolverse`)
};

const pt_yt_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloader de Miniaturas do YouTube — Obtenha Miniaturas HD | Toolverse`)
};

const ja_yt_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTubeサムネイルダウンローダー — HDサムネイルを取得 | Toolverse`)
};

const zh_yt_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube 缩略图下载器 — 获取 HD 缩略图 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_hub_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_hub_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_hub_meta_title", locale)
	if (locale === "en") return en_yt_hub_meta_title(inputs)
	if (locale === "es") return es_yt_hub_meta_title(inputs)
	if (locale === "de") return de_yt_hub_meta_title(inputs)
	if (locale === "nl") return nl_yt_hub_meta_title(inputs)
	if (locale === "fr") return fr_yt_hub_meta_title(inputs)
	if (locale === "it") return it_yt_hub_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_yt_hub_meta_title(inputs)
	if (locale === "pt") return pt_yt_hub_meta_title(inputs)
	if (locale === "ja") return ja_yt_hub_meta_title(inputs)
	return zh_yt_hub_meta_title(inputs)
};